interface CropArea {
  x: number;
  y: number;
  width: number;
  height: number;
}

const createImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', error => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });

export const getCroppedImg = async (
  imageSrc: string,
  cropArea: CropArea,
): Promise<Blob> => {
  try {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      throw new Error('Failed to get canvas context');
    }

    // Set canvas size to the dimensions of the crop area
    canvas.width = cropArea.width;
    canvas.height = cropArea.height;

    // Draw the cropped portion of the image onto the canvas without resizing
    ctx.drawImage(
      image,
      cropArea.x,
      cropArea.y,
      cropArea.width,
      cropArea.height,
      0, // dx: draw at the top-left corner of the canvas
      0, // dy: draw at the top-left corner of the canvas
      cropArea.width, // dWidth: draw with the original cropped width
      cropArea.height, // dHeight: draw with the original cropped height
    );

    // Convertir le canvas en blob
    return new Promise((resolve, reject) => {
      canvas.toBlob(
        blob => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Failed to create blob from canvas'));
          }
        },
        'image/png',
        1.0,
      );
    });
  } catch (err) {
    const error = err instanceof Error ? err.message : 'Unknown error';
    throw new Error(`Image cropping failed: ${error}`);
  }
};

export const calculateImageDimensions = (
  imageWidth: number,
  imageHeight: number,
  containerWidth: number,
  containerHeight: number,
) => {
  const imageRatio = imageWidth / imageHeight;
  const containerRatio = containerWidth / containerHeight;

  let width = containerWidth;
  let height = containerHeight;

  if (imageRatio > containerRatio) {
    // L'image est plus large que le conteneur
    height = width / imageRatio;
  } else {
    // L'image est plus haute que le conteneur
    width = height * imageRatio;
  }

  return {
    width,
    height,
    scale: Math.max(containerWidth / imageWidth, containerHeight / imageHeight),
  };
};
